// extracted by mini-css-extract-plugin
export default {"popover":"popover--TiFUt","popoverScrollView":"popoverScrollView--nqyaJ"};